import { NotificationData } from "../NotificationData";

export class NotificationPostData extends NotificationData {
  setup(data: any) {
    super.setup(data);
    this.type = NotificationData.types.NEW_EVENT_ATTENDEE;

    if (data.notificationData) {
      this.body = typeof data.notificationData?.body === "string" ? data.notificationData?.body : "";
      this.title = typeof data.notificationData?.title === "string" ? data.notificationData?.title : "";

      const postID = typeof data.notificationData?.postID === "string" ? data.notificationData?.postID : "";

      this.redirectPath = `/social?tab=posts#${postID}`;
    }
  }
}
